// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

export interface CardListHeadingStyles {
    containerGridItem?: GridItemProps;
    containerWrapper?: InjectableCss;
    titleGridItem?: GridItemProps;
    viewAllGridItem?: GridItemProps;
    viewAllStyles?: LinkPresentationProps;
}

// Xng-Changes: please check CardListHeadingExtensions.ts for styles
export const cardListHeadingStyles: CardListHeadingStyles = {};

const styles = cardListHeadingStyles;

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return (
        <GridItem {...styles.containerGridItem}>
            <StyledWrapper {...styles.containerWrapper}>
                <Typography className="card-list-heading" variant="h2">
                    {heading}
                </Typography>
                {viewAllUrl && (
                    <Link
                        href={viewAllUrl}
                        className="view-all-link"
                        data-test-selector="cardListHeadingViewAllLink"
                        {...styles.viewAllStyles}
                    >
                        {translate("View All")}
                        <VisuallyHidden>
                            {translate("View All")} {heading}
                        </VisuallyHidden>
                    </Link>
                )}
            </StyledWrapper>
        </GridItem>
    );
};

export default CardListHeading;
